import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import SettingsIcon from '@mui/icons-material/Settings';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Card,
  CardContent,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  CircularProgress,
  Link,
  Avatar,
  InputAdornment,
    Switch,
} from '@mui/material';

import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs';
import { Helmet } from 'react-helmet-async';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Iconify from '../components/iconify';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Scrollbar from '../components/scrollbar/Scrollbar';
import countries from './countryJson/countryJson.json';
import { Api, UploadFile } from '../webservices';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { md: '50%', xs: '95%' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  border: '3px solid #3C6BA5',
  borderRadius: 3,
};

const styless = {
  position: 'absolute',
  top: '48%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { md: '50%', xs: '95%' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  border: '3px solid #3C6BA5',
  borderRadius: 3,
};

const style1 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { md: '50%', xs: '95%' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  border: '2px solid #3C6BA5',
  borderRadius: 3,
};

const styleActive = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { md: '70%', xs: '95%' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  border: '5px solid #3C6BA5',
  borderRadius: 2,
  maxHeight: '89%',
  overflowY: 'auto',
};

function AddCompany() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [edit, setEdit] = useState(false);
  const [status, setStatus] = useState('active');
  const [role, setRole] = React.useState('Admin');
  const [editTrue, setEditTrue] = React.useState(true);
  const [valuee, setValuee] = useState('company');

  useEffect(() => {
    // setTableData([])
    getCompany();

    getIndividualLsit();
  }, []);

  // useEffect(() => {
  //   setTableData([])
  //   if(valuee === "company"){
  //     getCompany();
  //   } else {
  //     getIndividualLsit()
  //   }
  // }, [valuee]);

  // modal 1
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  // modal 2
  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);

  const tableLabel =
    valuee === 'company'
      ? [
          { id: 1, label: 'Company Name' },
          // { id: 2, label: 'Role' },
          // { id: 3, label: 'Email' },
          { id: 2, label: 'Official Domain' },
          { id: 3, label: 'Total Users' },
          // { id: 6, label: 'Mobile Number' },
          // { id: 7, label: 'Address' },
          { id: 6, label: 'Email Limit' },
          { id: 7, label: 'Download Limit' },
          { id: 4, label: 'Action' },
        ]
      : [
          { id: 1, label: 'Name' },
          { id: 2, label: 'Email' },
          { id: 3, label: 'Password' },
          { id: 4, label: 'Phone' },
          { id: 5, label: 'D.B.O' },
          { id: 6, label: 'Company' },
          { id: 7, label: 'Years' },
          { id: 8, label: 'Action' },
        ];



  const [formValuesAddComapnny, setFormValuesAddCompany] = useState({
    cName: '',
    role: 'recruiterManager',
    email: '',
    domain: '',
    ContactPersonName: '',
    contactNumber: '',
    password: '',
    address: '',
  });

  const [timez, setTimez] = useState('');

  const setContact = (e) => {
    const reg = /^[a-zA-Z]*$/;
    if (e.length) {
      const lst = e[e.length - 1];
      if (!lst.match(reg)) {
        setFormValuesAddCompany({
          ...formValuesAddComapnny,
          contactNumber: e,
        });
      }
    } else {
      setFormValuesAddCompany({
        ...formValuesAddComapnny,
        contactNumber: e,
      });
    }
  };

  const [loadingComp, setLoadingComp] = useState('');


  const getCompany = async () => {
    setTableData([]);
    setLoadingComp('Loading...');
    const token = localStorage.getItem('token');
    Api(`company/get_companies`, 'GET', '', token)
      .then((response) => {
        // console.log('=========getCompany======>>>>>>>', response.data.message);
        // console.log('=========getCompany======>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.data?.length) {
            // toast.success(response.data.message, +'!');
            setTableData(response.data.data);
            setLoadingComp('');
          } else {
            setLoadingComp('');
            setLoadingComp('No data found');
          }
        } else {
          toast.warn(response.data.message, +'!');
          setLoadingComp('No data found');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const [tableCount, setTableCount] = useState('');

  const getIndividualLsit = (value) => {
    // alert(value)
    const body = {
      limit: '35',
      page: value || '1',
    };
    const token = localStorage.getItem('token');
    Api(`individual/individualList`, 'POST', body, token)
      .then((response) => {
        // console.log('=========getCompany======>>>>>>>', response.data.message);
        // console.log('=========getCompany======>>>>>>>', response);
        if (response.status === 200) {
          if (response.data?.paginatedItems?.length) {
            const totalPage = Math.ceil(response.data.count / 35);
            setPages(totalPage);
            // toast.success(response.data.message, +'!');
            setTableCount(response.data?.count);
            setTableData1(response.data?.paginatedItems);
            // console.log("response.data?.paginatedItems", response.data?.paginatedItems)
          }
        } else {
          // toast.warn(response.data.message, +'!');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const removeLogo = () => {
    setUploadedImg('');
    setFileInputFiles('');
  };

  const [country, setCountry] = useState(localStorage.getItem('country'));

  const addCompany = async (e) => {
    e.preventDefault();
    if (!formValuesAddComapnny.domain) {
      toast.warn('Domain Name is required!');
      return;
    }
    if (!formValuesAddComapnny.cName) {
      toast.warn('Company Name is required!');
      return;
    }
    const token = localStorage.getItem('token');
    const body = {
      companyName: formValuesAddComapnny.cName,
      officialDomain: formValuesAddComapnny.domain,
      logoUrl: uploadedImg,
      "country": country,
      //  "timeZone":timez

      timeZone: {
        shortName: timeZone.shortName,
        fullName: timeZone.fullName,
      },
    };
    Api(`company/save_company`, 'POST', body, token)
      .then((response) => {
        // console.log('===============>>>>>>>', response);
        if (response.status === 200) {
          // localStorage.setItem("companyLogo", response.data.company?.companyLogo)
          // alert(response.data.company.companyLogo)
          handleClose2();
          toast.success(response.data.message, +'!');
          getCompany();
          setFileInputFiles('');
          setFormValuesAddCompany({
            ...formValuesAddComapnny,
            cName: '',
            // role: '',
            email: '',
            domain: '',
            ContactPersonName: '',
            contactNumber: '',
            password: '',
            address: '',
          });
          setCountry(localStorage.getItem('country'));
          // setTableData(response.data.result)
        } else {
          toast.warn(response.data.message, +'!');
        }
      })

      .catch((err) => {
        toast.error(err, +'!');
        // console.log('===========', err);
      });
  };

  const funclick = () => {
    getCompany();
  };

  const [showModal, setShowModal] = useState(false);

  const modalOpene = () => {
    setShowModal(true);
  };
  const modalClosee = () => {
    setShowModal(false);
  };

  const [loading, setLoading] = useState('');
  const [fileInputFiles, setFileInputFiles] = useState();
  const [uploadedImg, setUploadedImg] = useState();
  const handleFileSelect = (e) => {
    setLoading('Please wait...');
    const file = e.target.files[0];
    setFileInputFiles(file);
    if (file) {
      uploadMulti(file);
    }
  };

  const uploadMulti = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'profile');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        const uploadedImageUrl = response.data.filePath;
        setUploadedImg(response.data.filePath);
        //   setProfileImage(uploadedImageUrl);
        // UploadImage(uploadedImageUrl)
        //   setImagePreview(URL.createObjectURL(file));
      } else {
        //   toast.warn(response.data.status + '!');
      }
    } catch (error) {
      // toast.warn('Error uploading the image!');
    }
  };

  // const [tab, setTab] = useState('company');

  const handleTabChange = (Tab) => {
    // setTableData([])
    // setTab(Tab);
    setValuee(Tab);
  };

  // console.log("data", tableData1)

  const [searchResult, setSearchResult] = React.useState();
  const searchDataFun = (data) => {
    setTableData1([]);
    // alert('hhh')
    // setClientList(null)
    // setTableCount(count)
    // if (currentTab !== 'active') {
    //   setClientList('active')
    // }
    // setClientList(data)
    setTableData1(data);
    setValuee('user');
    // setSearchResult(data?.length)
    // setPages(totalPage)
    // console.log("data", data)
  };

  const resetTable = () => {
    getIndividualLsit();
  };

  const [searchResult1, setSearchResult1] = React.useState();
  const searchDataFun1 = (data) => {
    // console.log(data)
    setTableData([]);

    setTableData(data);
    setValuee('company');
    // setSearchResult(data?.length)
    // setPages(totalPage)
    // console.log("data", data)
  };

  const resetTable1 = () => {
    // getIndividualLsit()
    getCompany();
  };

  const [pages, setPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const handlePage = (event, value) => {
    setPageNumber(value);
    getIndividualLsit(value);
  };

  const [timeZone, setTimeZone] = useState({
    shortName: '',
    fullName: '',
  });

  const timeZones = [
    { short: 'EST', full: 'America/New_York' },
    { short: 'PST', full: 'America/Los_Angeles' },
    { short: 'MST', full: 'America/Denver' },
    { short: 'CST', full: 'America/Chicago' },
    { short: 'IST', full: 'Asia/Kolkata' },
  ];

  const handleChange = (event) => {
    const selectedShort = event.target.value;
    const selectedZone = timeZones.find((tz) => tz.short.toLowerCase() === selectedShort);

    if (selectedZone) {
      setTimeZone({
        shortName: selectedZone.short,
        fullName: selectedZone.full,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Company Management | Foxearch </title>
      </Helmet>

      {valuee === 'user' ? (
        <Search
          searchData={searchDataFun}
          func={resetTable}
          // funcc={hidePage}
          // funnc={showtable}
          //       onData1={handleDataFromChild1}
          //       onData2={handleDataFromChild2}
          resetSearch={() => setSearchResult('')}
        />
      ) : (
        <Search1
          searchData1={searchDataFun1}
          func={resetTable1}
          // funcc={hidePage}
          // funnc={showtable}
          //       onData1={handleDataFromChild1}
          //       onData2={handleDataFromChild2}
          resetSearch1={() => setSearchResult1('')}
        />
      )}

      <ToastContainer />
      <Stack flexDirection={'row'} justifyContent={'space-between'} mb={1}>
        {/* <Stack flexDirection={'row'}>
    <Typography variant="h5" color={'text.secondary'} >
      Company Management
    </Typography>
    <Typography variant="h5" color={'text.secondary'} sx={{ml:5}}>
      User Management
    </Typography>
  </Stack> */}

        <Stack sx={{ flexDirection: 'row', gap: 2, cursor: 'pointer', alignItems: 'center' }}>
          <Stack
            sx={[
              { flexDirection: 'row', alignItems: 'center' },
              valuee === 'company' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTabChange('company')}
          >
            {/* <Iconify
          icon="subway:world"
          fontSize={13}
          color={valuee === 'company' ? '#CB4335' : 'text.textG'}
        /> */}

            <Typography variant="tabs" color={'text.secondary'}>
              Company Management
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              valuee === 'user' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTabChange('user')}
          >
            {/* <Iconify
          icon="subway:world"
          fontSize={13}
          color={valuee === 'user' ? '#CB4335' : 'text.textG'}
        /> */}
            <Typography variant="tabs" color={'text.secondary'} sx={{}}>
              Individual Recruitment
            </Typography>
          </Stack>
        </Stack>
        {valuee === 'company' && (
          <Stack flexDirection={'row'} gap={1} alignItems="center">
            <Button color="custom" variant="contained" size="small" onClick={handleOpen2}>
              Add Company
            </Button>
          </Stack>
        )}
      </Stack>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'text.secondary' }}>
              {tableLabel.map((item) => {
                return (
                  <TableCell sx={{ p: 1, py: 0.5, color: 'white' }} key={item.id}>
                    {item.label}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {valuee === 'company'
              ? tableData &&
                tableData?.map((row, index) => (
                  <ManagementRow key={row._id} data={row} fun={funclick} valuee={valuee} />
                ))
              : tableData1?.map((row1, index) => (
                  <ManagementRow key={row1._id} data1={row1} getIndividualLsit={getIndividualLsit} valuee={valuee} />
                ))}
          </TableBody>
          {valuee === 'company' && loadingComp !== '' && (
            <Stack sx={{ mt: 1.5, p: 1, ml: '420px' }}>
              <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loadingComp}</Typography>
            </Stack>
          )}
        </Table>
      </TableContainer>
      {valuee !== 'company' &&
        (tableCount > 35 ? (
          <Stack
            spacing={2}
            sx={{
              width: '100%',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center',
              mt: 2,
            }}
          >
            {/* {pageNumber !== 1 && ( */}
            <Button
              variant="outlined"
              sx={{
                minWidth: 16,
                height: 32,
                borderRadius: '5px',
                mt: 2,
                ml: 0.5,
                cursor: 'pointer',
              }}
              onClick={() => setPageNumber((prev) => Math.max(prev - 1, 1))}
            >
              {'<'}
            </Button>
            {/* )} */}

            <Pagination
              variant="outlined"
              shape="rounded"
              color="secondary"
              hideNextButton
              hidePrevButton
              count={pages}
              page={pageNumber}
              onChange={handlePage}
              sx={{ cursor: 'pointer', mb: pageNumber !== 1 ? -4 : -2 }}
            />
            {/* {pageNumber !== pages && ( */}
            <Button
              variant="outlined"
              sx={{
                minWidth: 16,
                height: 32,
                borderRadius: '5px',
                mr: 1,
                mt: -2,
                cursor: 'pointer',
              }}
              onClick={() => setPageNumber((prev) => Math.min(prev + 1, pages))}
            >
              {'>'}
            </Button>
            {/* )} */}
          </Stack>
        ) : null)}

      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* <form onSubmit={(e) => addCompany(e)}> */}
          <Scrollbar sx={{ maxHeight: { sm: 500, xs: 400 } }}>
            <Grid
              display={'grid'}
              py={1}
              pr={{ xs: 1 }}
              gap={2}
              gridTemplateColumns={{ xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' }}
            >
              {/* <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Role</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Role"
                    placeholder="Role"
                    value={formValuesAddComapnny.role}
                    onChange={(e) =>
                      setFormValuesAddCompany({
                        ...formValuesAddComapnny,
                        role: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="recruiterManager">Recruiter Manager</MenuItem>
                    <MenuItem value="salesManager">Sales Manager</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  id="outlined-basic"
                  type="email"
                  name="email"
                  label="Email"
                  placeholder="Email"
                  variant="outlined"
                  value={formValuesAddComapnny.email}
                  onChange={(e) =>
                    setFormValuesAddCompany({
                      ...formValuesAddComapnny,
                      email: e.target.value,
                    })
                  }
                /> */}
              <TextField
                id="outlined-basic"
                name="domain"
                label="Official Domain"
                placeholder="Official Domain"
                variant="outlined"
                value={formValuesAddComapnny.domain}
                onChange={(e) =>
                  setFormValuesAddCompany({
                    ...formValuesAddComapnny,
                    domain: e.target.value,
                  })
                }
              />
              <TextField
                id="outlined-basic"
                name="Company Name"
                label="Company Name"
                placeholder="Company Name"
                variant="outlined"
                value={formValuesAddComapnny.cName}
                onChange={(e) =>
                  setFormValuesAddCompany({
                    ...formValuesAddComapnny,
                    cName: e.target.value,
                  })
                }
              />
              {/* <TextField
                  id="outlined-basic"
                  name="contactNumber"
                  label="Contact Number"
                  placeholder="Contact Number"
                  variant="outlined"
                  value={formValuesAddComapnny.contactNumber}
                  // type="number"
                  onChange={(e) => setContact(e.target.value)}
               
                />
                <Stack className="passwordIcon">
                  <TextField
                    id="outlined-basic"
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    label="Password"
                    placeholder="Password"
                    variant="outlined"
                    value={formValuesAddComapnny.password}
                    onChange={(e) =>
                      setFormValuesAddCompany({
                        ...formValuesAddComapnny,
                        password: e.target.value,
                      })
                    }
                  />
                  <Iconify
                    icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </Stack> */}

              <FormControl variant="outlined" fullWidth>
                <InputLabel>Select Country</InputLabel>
                <Select value={country} onChange={(e) => setCountry(e.target.value)} label="Select Country">
                  {/* <MenuItem value="USA">USA</MenuItem>
                                    <MenuItem value="CANADA">CANADA</MenuItem>
                                     <MenuItem value={'INDIA'}>INDIA</MenuItem>; */}

                  {countries?.map((item) => (
                    <MenuItem key={item.id} value={item.country}>
                      {item.country}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* <FormControl size="large" sx={{ width: '100%'}}>
                                  <InputLabel id="demo-simple-select-autowidth-label">Time zone</InputLabel>
                                  <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    label="Time Zone"
                                    InputLabelProps={{ shrink: true }}
                                    placeholder="Time zone"
                                    value={timez}
                                    onChange={(e) => setTimez(e.target.value)}
                                  >
                                    <MenuItem value={'est'}>EST</MenuItem>
                                    <MenuItem value={'pst'}>PST</MenuItem>
                                    <MenuItem value={'mst'}>MST</MenuItem>
                                    <MenuItem value={'cst'}>CST</MenuItem>
                                    <MenuItem value={'ist'}>IST</MenuItem>
                                  </Select>
                   </FormControl> */}

              <FormControl fullWidth sx={{}}>
                <InputLabel id="time-zone-label">Time Zone</InputLabel>
                <Select
                  labelId="time-zone-label"
                  id="time-zone-select"
                  label="Time Zone"
                  value={timeZone.shortName?.toLowerCase() || ''}
                  onChange={handleChange}
                >
                  {timeZones.map((tz) => (
                    <MenuItem key={tz.short} value={tz.short?.toLowerCase()}>
                      {tz.short}
                      {' - '}
                      {tz.full}
                    </MenuItem>
                  ))}
                </Select>

                {/* <div style={{ marginTop: "10px" }}>
                           <strong>Selected Time Zone:</strong> {timeZone.shortName} ({timeZone.fullName})
                         </div> */}
              </FormControl>
            </Grid>
          </Scrollbar>
          <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>
            <Grid item>
              <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                <div
                  style={{
                    border: '2px dashed #1E74B3',
                    padding: '5px',
                    borderRadius: '15px',
                    // margin: '1rem',
                    marginTop: '0.7rem',
                    textAlign: 'center',
                    color: '#1E74B3',
                    width: '200px',
                  }}
                >
                  <Typography variant="body1" fontWeight="bold" mb={1} mt={1}>
                    Upload Logo
                  </Typography>
                  <input
                    id="file-upload"
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={handleFileSelect}
                  />
                </div>
              </label>
            </Grid>

            <Grid item>
              {/* {loading} */}
              <Typography variant="body1" sx={{ ml: 2.5, mt: 1.8, fontSize: '16px' }}>
                {fileInputFiles?.name?.length > 10 ? `${fileInputFiles.name.slice(0, 25)}...` : fileInputFiles?.name}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1" sx={{ ml: 1.6, mt: 2, color: 'green', fontSize: '16px' }}>
                {fileInputFiles?.name ? 'Success' : ''}
              </Typography>
            </Grid>
            {fileInputFiles?.name ? (
              <Iconify
                sx={{ ml: 2.1, mt: 2.1, cursor: 'pointer' }}
                icon="oui:cross-in-circle-empty"
                color="red"
                onClick={() => removeLogo()}
              />
            ) : (
              ''
            )}
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Button color="custom" variant="contained" onClick={(e) => addCompany(e)}>
              Add
            </Button>
            {/* <Button color="custom" variant="contained" 
            sx={{ml:2}}
            onClick={() => modalOpene()}>
                Add Logo
            </Button> */}
          </Box>

          {/* </form> */}
        </Box>
      </Modal>

      {/* <Modal
                open={showModal}
                onClose={modalClosee}
            >
                <Box sx={{
                 position: 'absolute',
                 top: '50%',
                 left: '50%',
                 transform: 'translate(-50%, -50%)',
                 width: '30%',
                 backgroundColor: 'white',
                 border: '4px solid #1E74B3',
                 borderRadius: '13px',
                 padding: '1rem',
                 outline: 'none',
                 height: 'auto'
                }}>
                    
                  
                    <Typography
  variant="body1"
  sx={{ mx: 'auto', textAlign: 'center', fontWeight:"bold",
     fontSize:"20px", color:'#3C6BA5', }}
  
>
{loading}
</Typography>

                   <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
            <div
              style={{
                border: '3px dashed #1E74B3',
                padding: '10px',
                borderRadius: '15px',
                margin: '1rem',
                
                textAlign: 'center',
                color: '#1E74B3',
               
                marginLeft: '25',
                alignContent: 'center',
              }}
            >
              <Typography variant="body1" fontWeight="bold" mb={1} mt={1}>
                Upload Image
              </Typography>
              <input 
              id="file-upload"
              type="file" 
              style={{ display: 'none' }}
              accept="image/png, image/jpeg, image/jpg" 
              onChange={handleFileSelect} 
           
              />

            </div>
          </label>
           
              <Typography
  variant="body1"
  sx={{ mx: 'auto', textAlign: 'center' }}
  
>
  {fileInputFiles?.name}
</Typography>

           
                </Box>
            </Modal> */}
    </>
  );
}

function ManagementRow({ data, fun, valuee, data1, getIndividualLsit }) {
  // modal 0
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [emailCopy, setEmailCopy] = useState(false);

  const [openConfirm, setOpenConfirm] = useState(false);
  const confirmClose = () => setOpenConfirm(false);
  const openFoxdb = () => setOpenConfirm(true);

  const [openConfirm1, setOpenConfirm1] = useState(false);
  const confirmClose1 = () => setOpenConfirm1(false);
  const openAcceesGranted = () => setOpenConfirm1(true);

  const [openConfirm11, setOpenConfirm11] = useState(false);
  const confirmClose11 = () => setOpenConfirm11(false);
  const openIndividual = () => setOpenConfirm11(true);

  const [openConfirmC, setOpenConfirmC] = useState(false);
  const confirmCloseC = () => setOpenConfirmC(false);
  const openIndividualC = () => setOpenConfirmC(true);

  const [openConfirmInd, setOpenConfirmInd] = useState(false);
  const confirmCloseInd = () => setOpenConfirmInd(false);
  const openAcceesGrantedInd = () => setOpenConfirmInd(true);

  const [openConfirmInd1, setOpenConfirmInd1] = useState(false);
  const confirmCloseInd1 = () => setOpenConfirmInd1(false);
  const openAcceesGrantedInd1 = () => setOpenConfirmInd1(true);

  const [openDelete, setOpenDelete] = useState(false);
  const closeDeletefun = () => setOpenDelete(false);
  const openDeletefun = () => setOpenDelete(true);

  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const confirmCloseDelete = () => setOpenConfirmDelete(false);
  const confirmOpenDelete = () => setOpenConfirmDelete(true);

  const [openEditLimit, setOpenEditLimit] = useState(false);
  const editLimitOpen = () => setOpenEditLimit(true);
  const editLimitClose = () => setOpenEditLimit(false);

  const [openConfirActive, setOpenConfirmActive] = useState(false);
  const confirmCloseActive = () => setOpenConfirmActive(false);
  const [compIdd, setCompanyIdd] = useState('');
  const confirmOpenActive = (data) => {
    setCompanyIdd(data?._id);
    activeCompnaies('', '', data);
    setOpenConfirmActive(true);
  };

  const [loadingCompany, setLoadingCompany] = useState('');
  const [activeData, setActiveData] = useState([]);

  const [formValuesAddComapnny, setFormValuesAddCompany] = useState({
    cName: '',
    role: data?.role,
    email: data?.email,
    domain: data?.officialDomain,
    ContactPersonName: data?.contactPersonName,
    contactNumber: data?.contactNo,
    password: '',
    address: data?.companyAddress,
  });

  const [edit, setEdit] = useState(false);
  const [status, setStatus] = useState('active');
  const navigate = useNavigate();

  const [access, setAccess] = useState({
    rworksheet: '',
    client: '',
    lead: '',
    jobs: '',
    placeAndDatabase: '',
  });

  const setContact = (e) => {
    const reg = /^[a-zA-Z]*$/;
    if (e.length) {
      const lst = e[e.length - 1];
      if (!lst.match(reg)) {
        setFormValuesAddCompany({
          ...formValuesAddComapnny,
          contactNumber: e,
        });
      }
    } else {
      setFormValuesAddCompany({
        ...formValuesAddComapnny,
        contactNumber: e,
      });
    }
  };

  async function editFun(data) {
    const token = await localStorage.getItem('token');
    if (edit === false) {
      setEdit(true);
    } else if (edit === true) {
      const body = {
        companyId: data._id,
        email: formValuesAddComapnny.email ? formValuesAddComapnny.email : data.email,
        role: formValuesAddComapnny.role ? formValuesAddComapnny.role : data.role,
        password: formValuesAddComapnny.password ? formValuesAddComapnny.password : data.password,
        contactPersonName: formValuesAddComapnny.ContactPersonName
          ? formValuesAddComapnny.ContactPersonName
          : data.contactPersonName,
        contactNo: formValuesAddComapnny.contactNumber ? formValuesAddComapnny.contactNumber : data.contactNo,
        officialDomain: formValuesAddComapnny.domain ? formValuesAddComapnny.domain : data.domain,
        companyAddress: formValuesAddComapnny.address ? formValuesAddComapnny.address : data.companyAddress,
      };
      Api(`company/edit_company_details`, 'POST', body, token).then((Response) => {
        // console.log('======edit_company_details======>', JSON.stringify(Response));
        if (Response.status === 200) {
          setEdit(false);
          fun();
        }
      });
    }
  }

  async function statuss1(data) {
    const token = await localStorage.getItem('token');
    let sts = '';
    if (data.status === 'active') {
      sts = 'blocked';
    } else {
      sts = 'active';
    }
    const body = {
      companyId: data._id,
      status: sts,
    };
    Api(`company/company_status`, 'POST', body, token).then((Response) => {
      // console.log('======getUser==response=====>', Response);
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          // toast.success(Response.data.message);
          fun();
          // console.log('======getUser===data.data pdata====>', Response.data.data);
        } else {
          // console.log('======getUser=======>', +Response);
        }
      }
    });
  }

  const [reason, setReason] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword1, setShowPassword1] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword1((prev) => !prev);
  };

  async function statuss(data) {
    if (!reason && data.status === 'active') {
      toast.warn('Reason is required');
      return;
    }

    if (!password) {
      toast.warn('Password is required');
      return;
    }

    const token = await localStorage.getItem('token');
    let sts = '';
    if (data.status === 'active') {
      sts = 'inactive';
    } else {
      sts = 'active';
    }
    const body = {
      // companyId: data._id,
      company_id: data._id,
      status: sts,
      // status: "inactive",
      "password": password,
      "reason": reason,
    };
    // Api(`company/company_status`, 'POST', body, token).then((Response) => {
    Api(`company/acitveInactiveCompany`, 'POST', body, token).then((Response) => {
      // console.log('======getUser==response=====>', Response);
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          toast.success(Response.data.resmessage);
          fun();
          closeDeletefun();
          setReason('');
          setPassword('');
          // console.log('======getUser===data.data pdata====>', Response.data.data);
        } else {
          // console.log('======getUser=======>', +Response);
          // toast.warn(Response.data.resmessage);
        }
        // toast.warn(Response.data.resmessage);
      } else {
        toast.warn(Response.data.resmessage);
      }
    });
  }

  const giveAccess = (id) => {
    const token = localStorage.getItem('token');
    const body = {
      // companyId: id,
      company_id: id,
      access: 'fullaccess',
    };
    // Api(`company/grant_access`, 'POST', body, token).then((Response) => {
    Api(`database/removeDatabaseAccess`, 'POST', body, token).then((Response) => {
      // console.log('======give_access======>', JSON.stringify(Response));
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          toast.success(Response.data.remessage);
          fun();
          // console.log('======give_access===data.data pdata====>', Response.data.data);
        } else {
          // console.log('======give_access=======>', +Response);
        }
      }
    });
  };

  const giveAccessInd = (data1) => {
    const token = localStorage.getItem('token');
    const body = {
      individual_id: data1?._id,
      dbAccess: !data1?.dbAccess,
    };
    Api(`database/removeIndividualDbAccess`, 'POST', body, token).then((Response) => {
      // console.log('======give_access======>', JSON.stringify(Response));
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          toast.success(Response.data.resmessage);
          getIndividualLsit();
          confirmCloseInd();
          confirmCloseInd1();
          // console.log('======give_access===data.data pdata====>', Response.data.data);
        } else {
          // console.log('======give_access=======>', +Response);
        }
      }
    });
  };

  const giveAccess1 = (id) => {
    const token = localStorage.getItem('token');
    const body = {
      company_id: id,
      access: 'limited',
    };
    Api(`database/removeDatabaseAccess`, 'POST', body, token).then((Response) => {
      // console.log('======give_access======>', JSON.stringify(Response));
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          toast.success(Response.data.remessage);
          fun();
          // console.log('======give_access===data.data pdata====>', Response.data.data);
        } else {
          // console.log('======give_access=======>', +Response);
        }
      }
    });
  };

  const [openProfile, setOpenProfile] = useState(false);
  const [profile, setProfile] = useState('');
  const profileClose = () => setOpenProfile(false);
  const profileOpen = (data1) => {
    setProfile(data1.govPhotoID);
    setOpenProfile(true);
  };

  const [openStatus, setOpenStatus] = useState(false);
  const [id, setId] = useState('');
  const statusClose = () => setOpenStatus(false);
  const statusOpen = (data1) => {
    setId(data1._id);
    setOpenStatus(true);
  };

  const changeStatus = () => {
    const token = localStorage.getItem('token');

    const body = {
      status: 'rejected',
      indidual_id: id,
    };
    Api(`individual/changeStatusIndividual`, 'POST', body, token).then((Response) => {
      // console.log('======give_access======>', JSON.stringify(Response));
      if (Response.status === 200) {
        getIndividualLsit();
        toast.success(Response.data.resmessage);
        statusClose();
      }
    });
  };

  const changeStatus1 = (data1) => {
    const token = localStorage.getItem('token');
    const body = {
      status: 'approved',
      indidual_id: data1._id,
    };
    Api(`individual/changeStatusIndividual`, 'POST', body, token).then((Response) => {
      // console.log('======give_access======>', JSON.stringify(Response));
      if (Response.status === 200) {
        toast.success(Response.data.resmessage);
        getIndividualLsit();
      }
    });
  };

  const deleteInd = (id) => {
    const token = localStorage.getItem('token');
    const body = {
      individual_id: id,
      softDelete: 'delete',
    };
    Api(`database/softDeleteAndRevokeIndividualData`, 'POST', body, token).then((Response) => {
      // Api(`database/deleteIndividualData`, 'POST', body, token).then((Response) => {
      // console.log('======give_access======>', JSON.stringify(Response));
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          toast.success(Response.data.resmessage);
          getIndividualLsit();
        } else {
          toast.warn(Response.data.resmessage);
        }
      } else {
        toast.warn(Response.data.resmessage);
      }
    });
  };

  const deleteComp = (id) => {
    const token = localStorage.getItem('token');
    const body = {
      company_id: id,
      softDelete: 'delete',
    };
    // Api(`database/deleteCompanyDatabase`, 'POST', body, token).then((Response) => {
    Api(`database/softDeleteAndRevokeCompanyDatabase`, 'POST', body, token).then((Response) => {
      // console.log('======give_access======>', JSON.stringify(Response));
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          toast.success(Response.data.resmessage);
          fun();
        } else {
          toast.warn(Response.data.resmessage);
        }
      } else {
        toast.warn(Response.data.resmessage);
      }
    });
  };

  const deletePermaComp = (data) => {
    const token = localStorage.getItem('token');
    const body = {
      company_id: data?._id,
      deleteStatus: 'delete',
      reason: '',
      password: 'admin@2024',
    };

    Api(`company/hardDeleteCompany`, 'POST', body, token).then((Response) => {
      // console.log('======give_access======>', JSON.stringify(Response));
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          toast.success(Response.data.resmessage);
          fun();
        } else {
          toast.warn(Response.data.resmessage);
        }
      } else {
        toast.warn(Response.data.resmessage);
      }
    });
  };

  // console.log("openStatus", openStatus)

  const [indActive, setOpenIndActive] = useState(false);
  const closeIndActive = () => setOpenIndActive(false);
  const openIndActive = () => setOpenIndActive(true);

  const [reason1, setReason1] = useState('');

  const changeStatus2 = (data1) => {
    if (data1.status === 'active' && !reason1) {
      toast.warn('Reason is required');
      return;
    }

    const token = localStorage.getItem('token');
    let sts = '';
    if (data1.status === 'active') {
      sts = 'rejected';
    } else {
      sts = 'approved';
    }
    const body = {
      user_id: data1._id,
      status: sts,
      reason: reason1,
    };
    // Api(`company/changeCompanyAgent_status`, 'POST', body, token).then((Response) => {
    Api(`individual/changeIndividualStatus`, 'POST', body, token).then((Response) => {
      // console.log('======give_access======>', JSON.stringify(Response));
      if (Response.status === 200) {
        toast.success(Response.data.message);
        getIndividualLsit();
        closeIndActive();
        setReason1('');
      }
    });
  };

  const [showModal, setShowModal] = useState(false);
  const [compId, setCompId] = useState('');
  const modalOpene = (id) => {
    setCompId(id);
    setShowModal(true);
  };
  const modalClosee = () => {
    setShowModal(false);
  };

  const [loading, setLoading] = useState('');
  const [fileInputFiles, setFileInputFiles] = useState();

  const handleFileSelect = (e) => {
    setLoading('Please wait...');
    const file = e.target.files[0];
    setFileInputFiles(file);
    if (file) {
      uploadMulti(file);
    }
  };

  const uploadMulti = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'profile');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        const uploadedImageUrl = response.data.filePath;
        //   setProfileImage(uploadedImageUrl);
        UploadImage(uploadedImageUrl);
        //   setImagePreview(URL.createObjectURL(file));
      } else {
        //   toast.warn(response.data.status + '!');
      }
    } catch (error) {
      // toast.warn('Error uploading the image!');
    }
  };
  const UploadImage = (parseres) => {
    const body = {
      logoUrl: parseres,
      company_id: compId,
    };
    const token = localStorage.getItem('token');
    Api('company/companyLogoUpload', 'POST', body, token)
      .then((Response) => {
        if (Response.status === 200) {
          modalClosee();
          setFileInputFiles('');
          setLoading('');
          toast.success(Response.data.resmessage);
          fun();
          // localStorage.setItem("image", Response.data.profileUrl)
          // console.log("Profile image uploaded successfully!");
        } else {
          // console.error(`Error uploading profile image: ${Response.statusText}`);
        }
      })
      .catch((error) => {
        // console.error("Error during upload: ", error);
      });
  };

  const [showPassword, setShowPassword] = useState(true);

  // const activeInactive = [
  //   {
  //     "date": "Jan 1 2025",
  //     "green": 20,
  //     "red":35,
  //     "total": 5
  //   },
  //   {
  //     "date": "Jan 2 2025",
  //    "green": 20,
  //     "red":3,
  //     "total": 10
  //   },
  //   {
  //     "date": "Jan 3 2025",
  //     "green": 10,
  //     "red":33,
  //     "total": 15
  //   },
  //   {
  //     "date": "Jan 4 2025",
  //    "green": 40,
  //     "red":30,
  //     "total": 20
  //   },
  //   {
  //     "date": "Jan 5 2025",
  //     "green": 20,
  //     "red":30,
  //     "total": 25
  //   },
  //   {
  //     "date": "Jan 6 2025",
  //    "green": 20,
  //     "red":40,
  //     "total": 30
  //   },
  //   {
  //     "date": "Jan 7 2025",
  //     "green": 50,
  //     "red":30,
  //     "total": 35
  //   },
  //   {
  //     "date": "Jan 8 2025",
  //    "green": 20,
  //     "red":20,
  //     "total": 40
  //   },
  //   {
  //     "date": "Jan 9 2025",
  //    "green": 20,
  //     "red":36,
  //     "total": 45
  //   },
  //   {
  //     "date": "Jan 10 2025",
  //     "green": 27,
  //     "red":30,
  //     "total": 50
  //   },
  //   {
  //     "date": "Jan 11 2025",
  //     "green": 23,
  //     "red":30,
  //     "total": 55
  //   },
  //   {
  //     "date": "Jan 12 2025",
  //    "green": 23,
  //     "red":30,
  //     "total": 60
  //   },
  //   {
  //     "date": "Jan 13 2025",
  //    "green": 20,
  //     "red":30,
  //     "total": 65
  //   },
  //   {
  //     "date": "Jan 14 2025",
  //     "green": 20,
  //     "red":30,
  //     "total": 70
  //   },
  //   {
  //     "date": "Jan 15 2025",
  //    "green": 50,
  //     "red":30,
  //     "total": 75
  //   },
  //   {
  //     "date": "Jan 16 2025",
  //     "green": 90,
  //     "red":30,
  //     "total": 80
  //   },
  //   {
  //     "date": "Jan 17 2025",
  //     "green": 20,
  //     "red":30,
  //     "total": 85
  //   },
  //   {
  //     "date": "Jan 18 2025",
  //     "green": 28,
  //     "red":30,
  //     "total": 90
  //   },
  //   {
  //     "date": "Jan 19 2025",
  //     "green": 20,
  //     "red":31,
  //     "total": 95
  //   },
  //   {
  //     "date": "Jan 20 2025",
  //     "green": 30,
  //     "red":30,
  //     "total": 90
  //   }
  // ]

  const currentDate = new Date();
  const [selectedDate, setSelectedDate] = useState(new Date(currentDate?.getFullYear(), currentDate?.getMonth()));

  const formatDateWithOffset = (d) => {
    const isoString = d?.toISOString();
    return isoString?.replace('Z', '+00:00');
  };

  const [startDate1, setStartDate1] = useState(() => {
    const startOfMonth = new Date(currentDate?.getFullYear(), currentDate?.getMonth(), 1);
    return formatDateWithOffset(startOfMonth);
  });

  const [endDate1, setEndDate1] = useState(() => {
    const endOfMonth = new Date(currentDate?.getFullYear(), currentDate?.getMonth() + 1, 0);
    return formatDateWithOffset(endOfMonth);
  });

  const getStartEndOfMonth = (date) => {
    const startDate = new Date(date?.getFullYear(), date?.getMonth(), 1);
    const endDate = new Date(date?.getFullYear(), date?.getMonth() + 1, 0);

    const startDateFormatted = formatDateWithOffset(startDate);
    const endDateFormatted = formatDateWithOffset(endDate);
    // setStartDate1(startDate)
    // setEndDate1(endDate)
    return { startDate: startDateFormatted, endDate: endDateFormatted };
  };

  const handlePreviousMonth = () => {
    const newDate = new Date(selectedDate);
    newDate?.setMonth(selectedDate?.getMonth() - 1);
    setSelectedDate(newDate);

    const { startDate, endDate } = getStartEndOfMonth(newDate);
    activeCompnaies(startDate, endDate, '');
    // setStartDate1(startDate)
    // setEndDate1(endDate)
  };

  const handleNextMonth = () => {
    const newDate = new Date(selectedDate);

    if (
      newDate?.getFullYear() < currentDate?.getFullYear() ||
      (newDate?.getFullYear() === currentDate?.getFullYear() && newDate?.getMonth() < currentDate?.getMonth())
    ) {
      newDate?.setMonth(selectedDate?.getMonth() + 1);
      setSelectedDate(newDate);

      const { startDate, endDate } = getStartEndOfMonth(newDate);
      activeCompnaies(startDate, endDate, '');
      //   setStartDate1(startDate)
      // setEndDate1(endDate)
    }
  };

  const getMonthYearString = () => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[selectedDate?.getMonth()]} ${selectedDate?.getFullYear()}`;
  };

  // console.log("selectedDate", selectedDate)
  const [load, setLoad] = useState('');

  async function activeCompnaies(startDate, endDate, data) {
    setActiveData([]);
    setLoad('');
    setLoadingCompany('Loading...');
    const token = await localStorage.getItem('token');

    const body = {
      companyId: compIdd || data._id,
      startingDate: startDate || startDate1,
      endDate: endDate || endDate1,
    };
    Api('company/trackUserList', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          setLoadingCompany('');
          setActiveData(Response.data?.result);
        } else {
          setLoadingCompany('No data found');
          setActiveData([]);
        }
      } else if (Response.status === 400) {
        setLoad(Response.data.resmessage);
        setLoadingCompany('No data found');
        setActiveData([]);
      }
    });
  }


const [openMainModal, setOpenMainModal] = useState(false);
const [openConfirmModal, setOpenConfirmModal] = useState(false);
const [openConfirmAIModal, setOpenConfirmAIModal] = useState(false);


const [selectedCompany, setSelectedCompany] = useState(null);
const [emailStatus, setEmailStatus] = useState(false);
const [newStatus, setNewStatus] = useState(false);
const [AIPermission, setAIPermission] = useState(false);
const [newAIStatus, setNewAIStatus] = useState(false);
const [downloadLimit, setDownloadLimit] = useState('');


const handleSettingsClick = (data) => {
  setSelectedCompany(data);
  setEmailStatus(data.emailNotification); // autofill
  setAIPermission(data.aiScreening)
  setOpenMainModal(true);
};

const handleSwitchChange = (e) => {
  setNewStatus(e.target.checked); 
  setOpenConfirmModal(true); 
};

const handleAISwitchChange = (e) => {
  setNewAIStatus(e.target.checked); 
  setOpenConfirmAIModal(true); 
};

const handleConfirmYes = async () => {

   const token = await localStorage.getItem('token');

    const body = {
      companyId: selectedCompany._id,
      status: newStatus,
    }
    try {
  Api('company/company_edit_email_notif', 'POST', body, token)
    .then((response) => {

      console.log("lessten is goos ==>>>", response)
      if (response.data.code === 200) {
    
          setOpenConfirmModal(false);
          setOpenMainModal(false);
          toast.success(response.data.message)
          fun();
      }
         else {
          console.log(response.data.message || "Something went wrong");
        }
      } 
    )
} catch (err) {
  console.log("Try Catch Error:", err);
}
};

const handleAIConfirmYes = async () => {

   const token = await localStorage.getItem('token');

    const body = {
      id: selectedCompany._id,
      aiScreening: newAIStatus,
    }
    try {
  Api('company/toggleAiScreening', 'POST', body, token)
    .then((response) => {

      console.log("lessten is goos ==>>>", response)
      if (response.data.code === 200) {
    
          setOpenConfirmAIModal(false);
          setOpenMainModal(false);
          toast.success(response.data.message)
          fun();
      }
         else {
          console.log(response.data.message || "Something went wrong");
        }
      } 
    )
} catch (err) {
  console.log("Try Catch Error:", err);
}
};

const handleSaveLimit = async () => {
  try {
    const token = await localStorage.getItem('token');
    const payload = {
      companyId: data._id,
      limit: Number(downloadLimit),
    };
// console.log("limit payload",payload)
    const res = await Api(
      'resume_down_limit/set',
      'POST',
      payload,
      token
    );

    if (res?.status) {
      // console.log('Download limit updated successfully', res.data);
      editLimitClose();
    }
  } catch (error) {
    console.log(
      'Error updating download limit:',
      error?.response?.data || error.message
    );
  }
};

  return (
    <>
      {valuee === 'company' ? (
        <TableRow key={data._id}>
          <TableCell sx={{ pl: 1 }}>
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
              <Avatar
                sx={{ cursor: 'pointer' }}
                src={data?.companyLogo}
                alt="photoURL"
                onClick={() => modalOpene(data?._id)}
              />

              <Typography
                color={'text.secondary'}
                sx={{
                  cursor: 'pointer',
                  ml: 1,
                  color: data.status === 'inactive' ? 'red' : '',
                }}
                onClick={() => (data.status === 'active' ? handleOpen() : '')}
              >
                {data.companyName}
              </Typography>

              {/* <Iconify
      icon="material-symbols-light:add-a-photo-rounded"
      color="#1E74B3"
      sx={{
        ml: 1, 
        height: 20, 
        width: 20,
        cursor: 'pointer',
      }}
      onClick={() => modalOpene(data)}
       
    /> */}
            </Stack>
          </TableCell>
          <TableCell sx={{ pl: 1 }}>
            {edit === true ? (
              <TextField
                id="outlined-basic"
                label="Official Domain"
                placeholder="Official Domain"
                variant="outlined"
                value={formValuesAddComapnny.domain}
                onChange={(e) =>
                  setFormValuesAddCompany({
                    ...formValuesAddComapnny,
                    domain: e.target.value,
                  })
                }
              />
            ) : (
              <span>{data.officialDomain}</span>
            )}
          </TableCell>
          <TableCell sx={{ pl: 2 }}>
            <Typography sx={{ cursor: 'pointer' }} onClick={() => confirmOpenActive(data)}>
              {data?.totalUserCount}
            </Typography>
          </TableCell>

          <TableCell sx={{ pl: 2 }}>
            <Typography
            // sx={{cursor:"pointer"}}
            >
              18
            </Typography>
          </TableCell>

          <TableCell sx={{ pl: 2 }}>
            <Typography
            // sx={{cursor:"pointer"}}
            >
              20
            </Typography>
          </TableCell>

          <TableCell sx={{ pl: 2 }}>
           

            {data.status === 'inactive' ? (


              <Stack flexDirection={'row'} gap={1}>

               
              <IconButton >
                <SettingsIcon onClick={() =>{console.log("Button Clicked"); handleSettingsClick(data)}} />
              </IconButton>
            
                
                
            
                <Button
                  color="custom"
                  type="submit"
                  variant="contained"
                  size="small"
                  onClick={() => confirmOpenDelete()}
                >
                  Delete 
                </Button>
                <Button color="custom" type="submit" variant="contained" size="small" onClick={() => openDeletefun()}>
                  Revoke
                </Button>
              </Stack>
            ) : (
              <Stack flexDirection={'row'} gap={1}>
              
              <IconButton onClick={() =>{console.log("Button Clicked"); handleSettingsClick(data)}}>
                <SettingsIcon />
              </IconButton>
         



                {/* <Button color="custom" type="submit" variant="contained" size="small" onClick={() => editFun(data)}>
            {edit === false ? 'edit' : 'save'}
          </Button> */}
                {data.access === 'fullaccess' ? (
                  <Button
                    color="custom"
                    type="submit"
                    variant="contained"
                    size="small"
                    onClick={() => openAcceesGranted(data)}
                  >
                    Access Granted
                  </Button>
                ) : (
                  <Button
                    color="custom"
                    type="submit"
                    variant="contained"
                    size="small"
                    sx={{ whiteSpace: 'nowrap', minWidth: 'auto' }}
                    onClick={() => openFoxdb()}
                  >
                    Foxearch DB
                  </Button>
                )}

                <Button
                  color="custom"
                  type="submit"
                  variant="contained"
                  size="small"
                  sx={{ whiteSpace: 'nowrap', minWidth: 'auto' }}
                  onClick={() => statuss1(data)}
                >
                  Download DB
                </Button>
                <Button
                  color="custom"
                  type="submit"
                  variant="contained"
                  size="small"
                  onClick={() => {
                    openDeletefun();
                    // statuss(data);
                  }}
                >
                  {/* Delete Account */}
                  Inactive
                </Button>
                <Button
                  color="custom"
                  type="submit"
                  variant="contained"
                  size="small"
                  onClick={() => navigate('/admins', { state: { id: data._id, cname: data.companyName } })}
                >
                  Admins
                </Button>
                {data?.access === 'limited' ? (
                  <Button
                    color="custom"
                    type="submit"
                    variant="contained"
                    size="small"
                    onClick={() => openIndividualC()}
                  >
                    Spam
                  </Button>
                ) : null}
                <Button
                  color="custom"
                  type="submit"
                  variant="contained"
                  size="small"
                  sx={{ whiteSpace: 'nowrap', minWidth: 'auto' }}
                  onClick={() => editLimitOpen()}
                >
                  Edit Limit
                </Button>
              </Stack>
            )}
          </TableCell>
        </TableRow>
      ) : (
        <TableRow key={data1._id}>
          <TableCell sx={{ pl: 1 }}>
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
              <Typography
                color={data1.individualStatus === 'rejected' ? 'red' : 'text.secondary'}
                sx={{ cursor: 'pointer' }}
              >
                {data1.contactPersonName}
              </Typography>
              <Iconify
                icon="devicon:linkedin"
                color={'text.textG'}
                sx={{
                  ml: 1,
                  height: 17,
                  width: 17,
                  cursor: 'pointer',
                }}
                onClick={() => window.open(data1?.LinkedInLink, '_blank')}
                // onClick={() => {
                //   if (row.linkedinUrl) {
                //     window.open(row.linkedinUrl, '_blank');
                //   }
                // }}
              />
              <Iconify
                icon="ic:baseline-photo"
                color="#1E74B3"
                sx={{
                  ml: 1,
                  height: 20.4,
                  width: 20.4,
                  cursor: 'pointer',
                }}
                onClick={() => profileOpen(data1)}
                // onClick={() => {
                //   if (row.linkedinUrl) {
                //     window.open(row.linkedinUrl, '_blank');
                //   }
                // }}
              />
            </Stack>
          </TableCell>

          <TableCell sx={{ pl: 1 }}>
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
              <Typography>{data1.email}</Typography>
              <CopyToClipboard text={data1.email} onCopy={() => setEmailCopy(true)}>
                <Iconify
                  icon="radix-icons:copy"
                  color={emailCopy ? 'text.secondary' : 'text.textG'}
                  sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                />
              </CopyToClipboard>
            </Stack>
          </TableCell>
          <TableCell sx={{ pl: 1 }}>
            <Stack sx={{ flexDirection: 'row', alignContent: 'center' }}>
              {showPassword ? (
                <>
                  <Typography sx={{ maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    *****************************
                  </Typography>
                  <Iconify
                    icon="mdi:eye"
                    sx={{ color: 'text.secondary', width: 20, height: 20, mt: -0.5, ml: 0.5 }}
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowPassword(false)}
                  />
                </>
              ) : (
                <>
                  <Typography sx={{ maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {data1?.password}
                  </Typography>
                  <Iconify
                    icon="el:eye-close"
                    sx={{ color: 'text.secondary', width: 20, height: 20, ml: 1, mt: -0.2 }}
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowPassword(true)}
                  />
                </>
              )}
            </Stack>
          </TableCell>
          <TableCell sx={{ pl: 1 }}>
            <Typography>{data1.contactNo}</Typography>
          </TableCell>
          <TableCell sx={{ pl: 1 }}>
            <Typography>
              {data1.DOB ? <>{moment(data1.DOB).format('ll')}</> : '-'}
              {/* {data1.DOB} */}
            </Typography>
          </TableCell>
          <TableCell sx={{ pl: 1 }}>
            <Typography>{data1.companyName}</Typography>
          </TableCell>
          <TableCell sx={{ pl: 1 }}>
            <Typography>{data1.yearOfExperience}</Typography>
          </TableCell>
          <TableCell sx={{ pl: 1 }}>
            <Stack flexDirection={'row'} gap={1}>
              {data1.dbAccess === true ? (
                <Button
                  color="custom"
                  type="submit"
                  variant="contained"
                  size="small"
                  onClick={() => openAcceesGrantedInd1()}
                >
                  Access Granted
                </Button>
              ) : (
                <Button
                  color="custom"
                  type="submit"
                  variant="contained"
                  size="small"
                  sx={{ whiteSpace: 'nowrap', minWidth: 'auto' }}
                  onClick={() => openAcceesGrantedInd()}
                >
                  Foxearch DB
                </Button>
              )}

              {data1.individualStatus === '' ? (
                <>
                  <Button
                    color="custom"
                    type="submit"
                    variant="contained"
                    size="small"
                    onClick={() => changeStatus1(data1)}
                  >
                    Approve
                  </Button>
                  <Button
                    color="custom"
                    type="submit"
                    variant="contained"
                    size="small"
                    onClick={() => statusOpen(data1)}
                  >
                    Reject
                  </Button>
                </>
              ) : data1.individualStatus === 'rejected' ? (
                <Button
                  color="custom"
                  type="submit"
                  variant="contained"
                  size="small"
                  onClick={() => changeStatus1(data1)}
                >
                  Approve
                </Button>
              ) : (
                <>
                  <Button
                    color="custom"
                    type="submit"
                    variant="contained"
                    size="small"
                    onClick={() =>
                      // changeStatus2(data1)
                      openIndActive()
                    }
                  >
                    {data1.status === 'active' ? 'Active' : 'Inactive'}
                  </Button>
                </>
              )}
              <Button
                color="custom"
                type="submit"
                variant="contained"
                size="small"
                // onClick={()=>changeStatus2(data1)}
                onClick={() => openIndividual()}
              >
                {/* {data1.status === "active"?"Active":"Inactive"} */}
                Spam
              </Button>
            </Stack>
          </TableCell>
        </TableRow>
      )}

      {/* <Modal open={openMainModal} onClose={() => setOpenMainModal(false)}>
  <Box sx={{ ...style, width: 300 }}>
    <Stack spacing={2} alignItems="center">

      <Typography variant="h6">
        Email Notification
      </Typography>

      <Switch
        checked={emailStatus}
        onChange={handleSwitchChange}
      />

    </Stack>
  </Box>
      </Modal> */}

      {/* <Modal open={openConfirmModal} onClose={() => setOpenConfirmModal(false)}>
  <Box sx={{ ...style, width: 300 }}>
    <Stack alignItems="center" spacing={2}>

      <Typography color="red" variant="h6">
        {newStatus ? 'Turn ON Email Notification?' : 'Turn OFF Email Notification?'}
      </Typography>

      <Stack direction="row" spacing={2}>
        <Button variant="contained" size="small" onClick={handleConfirmYes}>
          Yes
        </Button>

        <Button
          variant="contained"
          size="small"
          onClick={() => setOpenConfirmModal(false)}
        >
          No
        </Button>
      </Stack>

    </Stack>
  </Box>
        </Modal> */}

        <Modal open={openMainModal} onClose={() => setOpenMainModal(false)}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '50%',
      bgcolor: 'background.paper',
      boxShadow: 24,
      px: 3,
      py: 2,
      borderRadius: 2,
    }}
  >
    <Stack spacing={2}>

      {/* Heading */}
      <Typography variant="h6" textAlign="center">
        Settings
      </Typography>

      <Divider />

      <Grid container spacing={2}>
  {/* AI Details */}
  <Grid item xs={12} sm={5.8}>
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" fontWeight={600} mb={2} color="text.secondary">
          AI Billing
        </Typography>

        <Stack spacing={2}>
          <Box>
            <Typography variant="body2">
              Amount
            </Typography>
            <Typography fontWeight={800} color="text.secondary">
            {data.claudeBilling?.totalCost || "-"} {" "} {data.claudeBilling?.currency || "-"}
            </Typography>
          </Box>

          {/* <Divider />

          <Box>
            <Typography variant="body2" color="text.secondary">
              Price
            </Typography>
            <Typography variant="h6" fontWeight={600}>
              {data.claudeBilling?.totalCost || "-"}
            </Typography>
          </Box> */}
        </Stack>
      </CardContent>
    </Card>
  </Grid>

  {/* Email Details */}
  <Grid item xs={12} sm={5.8}>
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" fontWeight={600} mb={2} color="text.secondary">
          Email Billing
        </Typography>

        <Stack spacing={2}>
          <Box>
            <Typography variant="body2" >
              Amount
            </Typography>
            <Typography fontWeight={800} color="text.secondary">
             {data.sesBilling?.totalCost ||  "-"} {" "} {data.sesBilling?.currency || "-"}
            </Typography>
          </Box>

          {/* <Divider />

          <Box>
            <Typography variant="body2" color="text.secondary">
              Price
            </Typography>
            <Typography variant="h6" fontWeight={600}>
              {data.sesBilling?.totalCost ||  "-"}
            </Typography>
          </Box> */}
        </Stack>
      </CardContent>
    </Card>
  </Grid>
</Grid>

      {/* Email Notification */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography>Email Notification</Typography>

        <Switch
          checked={emailStatus}
          onChange={handleSwitchChange}
        />
      </Stack>

       {/* AI Notification */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography>AI Permission</Typography>

        <Switch
          checked={AIPermission}
          onChange={handleAISwitchChange}
        />
      </Stack>

      {/* Future me aur options add karne ke liye yaha copy karo 👇 */}

      {/* Example */}
      {/* 
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography>SMS Notification</Typography>
        <Switch />
      </Stack>
      */}

    </Stack>
  </Box>
</Modal>

        <Modal open={openConfirmModal} onClose={() => setOpenConfirmModal(false)} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
             {newStatus ? 'Turn ON Email Notification?' : 'Turn OFF Email Notification?'}
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
             
                onClick={handleConfirmYes}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={() => setOpenConfirmModal(false)}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>


       <Modal open={openConfirmAIModal} onClose={() => setOpenConfirmAIModal(false)} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
             {newAIStatus ? 'Turn ON AI Permission?' : 'Turn OFF AI Permission?'}
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
             
                onClick={handleAIConfirmYes}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={() => setOpenConfirmAIModal(false)}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>





      <Modal open={showModal} onClose={modalClosee}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '30%',
            backgroundColor: 'white',
            border: '4px solid #1E74B3',
            borderRadius: '13px',
            padding: '1rem',
            outline: 'none',
            height: 'auto',
          }}
        >
          {/* <Typography 
                   variant="contained" textAlign={'center'} fontSize={"1rem"}>
                   Upload Profile Image 
                   </Typography> */}
          <Typography
            variant="body1"
            sx={{
              mx: 'auto',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#3C6BA5',
            }}
          >
            {loading}
          </Typography>

          <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
            <div
              style={{
                border: '3px dashed #1E74B3',
                padding: '10px',
                borderRadius: '15px',
                margin: '1rem',
                // justifyContent: 'center',
                // alignItems: 'center',
                textAlign: 'center',
                color: '#1E74B3',
                // width: '330px',
                marginLeft: '25',
                alignContent: 'center',
              }}
            >
              <Typography variant="body1" fontWeight="bold" mb={1} mt={1}>
                Upload Logo
              </Typography>
              <input
                id="file-upload"
                type="file"
                style={{ display: 'none' }}
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleFileSelect}
                //   single
              />
            </div>
          </label>
          {/* <div> */}
          {/* {/ <Typography variant="body1">Uploaded Files</Typography> /} */}
          <Typography variant="body1" sx={{ mx: 'auto', textAlign: 'center' }}>
            {fileInputFiles?.name}
          </Typography>

          {/* </div> */}
        </Box>
      </Modal>

      <Modal open={openStatus} onClose={statusClose} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
                Would You want to Reject this user?
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
                onClick={() => {
                  changeStatus();
                }}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={() => statusClose()}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Modal open={openEditLimit} onClose={editLimitClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '30%',
            bgcolor: 'background.paper',
            boxShadow: 24,
            // p: 3,
            px: 3,
            py: 2,
            border: '1px solid #3C6BA5',
            borderRadius: 2,
            // maxHeight:"89%",
            // overflowY: 'auto',
          }}
        >
          <Stack spacing={1.2} alignItems="center">
            <Typography variant="h6" color="text.secondary" textAlign="center">
              Edit Limit
            </Typography>

            <Divider sx={{ width: '100%', my: 0.9 }} />

            {/* <TextField
              fullWidth
              // label="Email Limit (0-9)"
              label="Email Limit"
              variant="outlined"
              size=""
              type="number"
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            /> */}
           <TextField
  fullWidth
  label="Download Limit"
  variant="outlined"
  type="number"
  value={downloadLimit}
  onChange={(e) => {
    setDownloadLimit(e.target.value);
    localStorage.setItem('downloadLimit', e.target.value);
  }}
  inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
/>

            <Stack direction="row" spacing={2} justifyContent="center" sx={{ paddingTop: 1 }}>
              <Button color="custom" variant="contained" onClick={handleSaveLimit} disabled={downloadLimit === '' || Number(downloadLimit) < 0}>
                Save
              </Button>
              <Button color="custom" variant="contained" onClick={editLimitClose}>
                Close
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Modal open={openProfile} onClose={profileClose} style={{ borderRadius: 10 }}>
        <Box sx={{ ...style1, width: { xs: '80%', sm: '50%', md: '30%' }, p: 3 }}>
          <Stack sx={{ justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography variant="h6" textAlign={'center'} color={'text.secondary'}>
                Profile
              </Typography>
              <Divider />
            </Stack>

            <Avatar src={profile || 'No Profile'} alt="Government Photo ID" sx={{ width: 150, height: 150, mt: 1 }} />
          </Stack>
        </Box>
      </Modal>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Scrollbar sx={{ maxHeight: 400 }}>
            <Typography id="modal-modal-description" variant="h6" sx={{ textAlign: 'center', color: 'text.secondary' }}>
              Access Management
            </Typography>
            <Divider />
            <Stack gap={2} sx={{ mt: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Recruiter Worksheet</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={access.rworksheet}
                  label="Recruiter Worksheet"
                  onChange={(e) => setAccess({ ...access, rworksheet: e.target.value })}
                >
                  <MenuItem value={'noaccess'}>No Access</MenuItem>
                  <MenuItem value={'limited'}>Limited Access</MenuItem>
                  <MenuItem value={'fullaccess'}>Full Access</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Client</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={access.client}
                  label="Client"
                  onChange={(e) => setAccess({ ...access, client: e.target.value })}
                >
                  <MenuItem value={'noaccess'}>No Access</MenuItem>
                  <MenuItem value={'limited'}>Limited Access</MenuItem>
                  <MenuItem value={'fullaccess'}>Full Access</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Lead</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={access.lead}
                  label="Lead"
                  onChange={(e) => setAccess({ ...access, lead: e.target.value })}
                >
                  <MenuItem value={'noaccess'}>No Access</MenuItem>
                  <MenuItem value={'limited'}>Limited Access</MenuItem>
                  <MenuItem value={'fullaccess'}>Full Access</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Jobs</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={access.jobs}
                  label="Jobs"
                  onChange={(e) => setAccess({ ...access, jobs: e.target.value })}
                >
                  <MenuItem value={'noaccess'}>No Access</MenuItem>
                  <MenuItem value={'limited'}>Limited Access</MenuItem>
                  <MenuItem value={'fullaccess'}>Full Access</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Placement & Database</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={access.placeAndDatabase}
                  label="Placement & Database"
                  onChange={(e) => setAccess({ ...access, placeAndDatabase: e.target.value })}
                >
                  <MenuItem value={'noaccess'}>No Access</MenuItem>
                  <MenuItem value={'limited'}>Limited Access</MenuItem>
                  <MenuItem value={'fullaccess'}>Full Access</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </Scrollbar>
          <Stack sx={{ alignItems: 'center' }} gap={1} mt={2}>
            <Button
              color="custom"
              variant="contained"
              sx={{ width: 100 }}
              // onClick={handleOpen}
            >
              save
            </Button>
          </Stack>
        </Box>
      </Modal>
      <Modal open={openConfirm} onClose={confirmClose} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
                {/* Would You want to access Foxearch DB ? */}
                Grant access to Foxearch DB ?
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
                onClick={() => {
                  confirmClose();
                  giveAccess(data._id);
                }}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={confirmClose}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Modal open={openConfirm1} onClose={confirmClose1} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
                Remove access to Foxearch DB ?
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
                onClick={() => {
                  confirmClose1();
                  giveAccess1(data._id);
                }}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={confirmClose1}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>


      <Modal open={openConfirm11} onClose={confirmClose11} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
                Would you want to delete this individual user ?
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
                onClick={() => {
                  confirmClose11();
                  deleteInd(data1._id);
                }}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={confirmClose11}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Modal open={openConfirmC} onClose={confirmCloseC} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
                Would you want to delete {data?.companyName} ?
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
                onClick={() => {
                  confirmCloseC();
                  deleteComp(data._id);
                }}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={confirmCloseC}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Modal open={openConfirmInd} onClose={confirmCloseInd} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
                {/* Would You want to access Foxearch DB ? */}
                Grant access to Foxearch DB ?
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
                onClick={() => {
                  confirmCloseInd();
                  giveAccessInd(data1);
                }}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={confirmCloseInd}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Modal open={openConfirmInd1} onClose={confirmCloseInd1} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
                Remove access to Foxearch DB ?
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
                onClick={() => {
                  confirmCloseInd1();
                  giveAccessInd(data1);
                }}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={confirmCloseInd1}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Modal open={indActive} onClose={closeIndActive} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
                Do you want to {data1?.status === 'active' ? 'Inactive' : 'active'} this user ?
              </Typography>
              {data1?.status === 'active' && (
                <TextField
                  sx={{ mt: 1 }}
                  label="Reason"
                  variant="outlined"
                  // size="small"
                  fullWidth
                  value={reason1}
                  onChange={(e) => setReason1(e.target.value)}
                />
              )}
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
                onClick={() => {
                  changeStatus2(data1);
                }}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={closeIndActive}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Modal open={openDelete} onClose={closeDeletefun} style={{ borderRadius: 10 }}>
        <Box sx={[styless, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography variant="h6" textAlign={'center'} color={'red'}>
                Do you want to delete {data?.companyName}?
              </Typography>
            </Stack>

            {data?.status === 'inactive' ? (
              <Stack direction="row" spacing={2} sx={{ width: '100%', mt: 2 }}>
                <TextField
                  label="Password"
                  variant="outlined"
                  type={showPassword1 ? 'text' : 'password'}
                  // size="small"
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => togglePasswordVisibility()} edge="end">
                          <Iconify icon={showPassword1 ? 'el:eye-close' : 'mdi:eye'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
            ) : (
              <Stack direction="row" spacing={2} sx={{ width: '100%', mt: 2 }}>
                <TextField
                  label="Reason"
                  variant="outlined"
                  // size="small"
                  fullWidth
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />

                <TextField
                  label="Password"
                  variant="outlined"
                  type={showPassword1 ? 'text' : 'password'}
                  // size="small"
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => togglePasswordVisibility()} edge="end">
                          <Iconify icon={showPassword1 ? 'el:eye-close' : 'mdi:eye'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
            )}

            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                variant="contained"
                size="small"
                onClick={() => {
                  statuss(data);
                }}
              >
                Yes
              </Button>
              <Button color="custom" variant="contained" size="small" onClick={closeDeletefun}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Modal open={openConfirmDelete} onClose={confirmCloseDelete} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography sx={{}} variant="h6" textAlign={'center'} color={'red'}>
                Would you want to permanent delete {data?.companyName} ?
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                sx={{}}
                variant="contained"
                size="small"
                onClick={() => {
                  deletePermaComp(data);
                  confirmCloseDelete();
                }}
              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size="small" onClick={confirmCloseDelete}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Modal open={openConfirActive} onClose={confirmCloseActive} style={{ borderRadius: 1 }}>
        <Box sx={[styleActive, {}]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: -2.5 }}
                variant="h6"
              >
                <Iconify
                  icon="ic:sharp-arrow-left"
                  width="3.2rem"
                  sx={{ color: ' #3C6BA5', cursor: 'pointer' }}
                  onClick={() => handlePreviousMonth()}
                />
                <span style={{ color: 'black', margin: '0 0.5rem', fontWeight: 'bold' }}>{getMonthYearString()}</span>
                <Iconify
                  icon="ic:sharp-arrow-right"
                  width="3.2rem"
                  sx={{ color: '#3C6BA5', cursor: 'pointer' }}
                  onClick={() => handleNextMonth()}
                />
              </Typography>

              <Scrollbar sx={{ maxHeight: 400, overflowY: 'auto' }}>
                <Stack direction="column">
                  {loadingCompany !== '' && (
                    <Stack sx={{ p: 1 }}>
                      <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loadingCompany}</Typography>
                    </Stack>
                  )}

                  {activeData?.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <div
                        style={{
                          width: '12%',
                          textAlign: 'center',
                          borderTop: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '3px solid black',
                          borderBottom: '3px solid black',
                          padding: '0.3rem',
                        }}
                      >
                        {/* {item?.date} */}
                        {new Date(item?.date).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                        })}
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          width: '87%',
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: '#90EE90',
                            // width: '50%',
                            width: `${Math.min((item.activeUser / item.totalUser) * 100)}%`,
                            height: '100%',
                            padding: '0.35rem',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                          }}
                        >
                          {item?.activeUser}
                        </div>
                        <div
                          style={{
                            backgroundColor: '#FF5B61',
                            // width: '50%',
                            width: `${Math.min((item.inactiveUser / item.totalUser) * 100)}%`,
                            height: '100%',
                            padding: '0.35rem',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                          }}
                        >
                          {item?.inactiveUser}
                        </div>
                        <div
                          style={{
                            width: '10%',
                            height: '100%',
                            padding: '0.35rem',
                            color: '#5e5a5a',
                          }}
                        >
                          Total - {item?.totalUser}
                        </div>
                      </div>
                    </div>
                  ))}
                </Stack>
              </Scrollbar>

              <Stack
                direction="row"
                // spacing={1}
                justifyContent="center"
                alignItems="center"
                sx={{ width: '100%', mt: 1.4, mb: 0.3 }}
              >
                <Typography
                  color="custom"
                  variant="contained"
                  sx={{ p: 1, backgroundColor: '#3C6BA5', color: 'white', borderRadius: '4px' }}
                >
                  Total Active Users for the Month{' : '}
                  {(
                    activeData?.reduce((total, item) => total + parseInt(item?.activeUser, 10), 0) /
                    new Date(new Date()?.getFullYear(), new Date()?.getMonth() + 1, 0)?.getDate()
                  )?.toFixed(2) || '0'}
                  {/* {activeData?.reduce((total, item) => total + (parseInt(item?.activeUser, 10) / new Date(item?.date)?.getDate()), 0) > 0 
  ? activeData?.reduce((total, item) => total + (parseInt(item?.activeUser, 10) / new Date(item?.date)?.getDate()), 0)?.toFixed(2) 
  : 0} */}
                </Typography>
              </Stack>

              <Stack
                direction="row"
                // spacing={1}
                justifyContent="center"
                alignItems="center"
                sx={{ width: '100%', mt: 1.4, mb: -1 }}
              >
                <Button color="custom" variant="contained" sx={{ width: '10%', p: 0.7 }}>
                  Invoice
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}

export default AddCompany;

const StyledIconButtonWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bold',
});

function Search({ searchData, func, funcc, funnc, resetSearch, onData, onData1, onData2 }) {
  const [formValues, setFormValues] = useState({
    commonSearch: '',
  });

  const [Values, setValues] = useState({
    commonSearch: '',
  });

  const [loadingData, setLoadingData] = useState('');
  const [loading, setLoading] = useState('');

  const [loading1, setLoading1] = useState(false);

  const fn = () => {
    setLoading1(true);
    const body = {
      email: formValues.commonSearch,
      // "page":page,
      // "limit":"35"
    };
    const token = localStorage.getItem('token');
    Api('individual/searchIndividualEmail', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          // alert("l")
          // const totalPage = Math.ceil(response.data?.count / 35)
          // searchData(response.data?.resmessage, response.data?.count, totalPage)
          searchData(response.data?.resmessage);
          setLoading1(false);
          // alert("h")
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  const [isVisible, setIsVisible] = useState(true);

  const toggleVisibility = () => {
    setFormValues({ ...formValues, commonSearch: '' });
    resetSearch();
    clearInputField();
    // setIsVisible(!isVisible);
    func();
  };

  const clearInputField = () => {
    setValues({
      ...Values,
      commonSearch: '',
    });
  };

  const sendDataToParent = () => {
    onData(clearInputField);
  };

  // const funn = (page) =>{
  //   fn(page)
  // }
  const sendDataToParent1 = () => {
    // onData1(CommonSearcFun, loadingData);
  };

  const [pageNumber, setPageNumber] = useState(1);
  // const [loading, setLoading] = useState(false);
  // const [loading1, setLoading1] = useState(false);

  const sendDataToParent2 = () => {
    onData2(pageNumber);
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', left: 115, right: 0 }}>
        <Paper
          component="form"
          sx={{
            // p: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            width: '25%',
            border: '1px solid #1E74B3',
            borderRadius: '10px',
            marginTop: -18,
          }}
        >
          {/* <IconButton sx={{ p: '0.1px', ml: "7px" }}>
              <Iconify icon="eva:search-outline" />
            </IconButton> */}
          <InputBase
            sx={{ flex: 1, color: 'text.primary', border: 'none', outline: 'none', pl: 1 }}
            placeholder="Email"
            inputProps={{ 'aria-label': 'search' }}
            value={formValues.commonSearch}
            onChange={(e) => setFormValues({ ...formValues, commonSearch: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                fn();
                // funcc();
                // sendDataToParent1()
              }
            }}
          />
        </Paper>
        {/* <Button style={{ marginLeft: '16px', color: 'white', backgroundColor: '#1E74B3', 
            borderRadius: '10px', marginTop: '4px', height: '41px', width: '130px' }} 
            onClick={fn}>Search</Button> */}
        <Button
          color="custom"
          variant="contained"
          size="small"
          sx={{ ml: 1.6, mt: -18 }}
          onClick={() => fn()}
          disabled={loading1}
        >
          {/* Search */}
          {loading1 ? <CircularProgress size={24} /> : 'Search'}
        </Button>
        {formValues.commonSearch && (
          <Button
            color="custom"
            variant="contained"
            size="small"
            sx={{ ml: 1.6, mt: -18 }}
            onClick={() => {
              toggleVisibility();
            }}
          >
            Close
          </Button>
        )}
      </div>
    </>
  );
}

function Search1({ searchData1, func, funcc, funnc, resetSearch1, onData, onData1, onData2 }) {
  const [formValues1, setFormValues1] = useState({
    commonSearch: '',
  });

  const [Values1, setValues1] = useState({
    commonSearch: '',
  });

  const [loadingData, setLoadingData] = useState('');
  const [loading, setLoading] = useState('');

  const [loading11, setLoading11] = useState(false);

  const fn = () => {
    setLoading11(true);
    const body = {
      //  "companyName":formValues1.commonSearch,
      //  "domain":formValues1.commonSearch
      commonSearch: formValues1.commonSearch,
      // "page":page,
      // "limit":"35"
    };
    const token = localStorage.getItem('token');
    Api('company/companySearch', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          // alert("l")
          // const totalPage = Math.ceil(response.data?.count / 35)
          // searchData(response.data?.resmessage, response.data?.count, totalPage)
          searchData1(response.data?.result);
          setLoading11(false);
          // alert("h")
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  const [isVisible, setIsVisible] = useState(true);

  const toggleVisibility1 = () => {
    setFormValues1({ ...formValues1, commonSearch: '' });
    resetSearch1();
    clearInputField();
    // setIsVisible(!isVisible);
    func();
  };

  const clearInputField = () => {
    setValues1({
      ...Values1,
      commonSearch: '',
    });
  };

  const sendDataToParent = () => {
    onData(clearInputField);
  };

  // const funn = (page) =>{
  //   fn(page)
  // }
  const sendDataToParent1 = () => {
    // onData1(CommonSearcFun, loadingData);
  };

  const [pageNumber, setPageNumber] = useState(1);
  // const [loading, setLoading] = useState(false);
  // const [loading1, setLoading1] = useState(false);

  const sendDataToParent2 = () => {
    onData2(pageNumber);
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', left: 115, right: 0 }}>
        <Paper
          component="form"
          sx={{
            // p: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            width: '25%',
            border: '1px solid #1E74B3',
            borderRadius: '10px',
            marginTop: -18,
          }}
        >
          {/* <IconButton sx={{ p: '0.1px', ml: "7px" }}>
              <Iconify icon="eva:search-outline" />
            </IconButton> */}
          <InputBase
            sx={{ flex: 1, color: 'text.primary', border: 'none', outline: 'none', pl: 1 }}
            placeholder="Company Name | Domain"
            inputProps={{ 'aria-label': 'search' }}
            value={formValues1.commonSearch}
            onChange={(e) => setFormValues1({ ...formValues1, commonSearch: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                fn();
                // funcc();
                // sendDataToParent1()
              }
            }}
          />
        </Paper>
        {/* <Button style={{ marginLeft: '16px', color: 'white', backgroundColor: '#1E74B3', 
            borderRadius: '10px', marginTop: '4px', height: '41px', width: '130px' }} 
            onClick={fn}>Search</Button> */}
        <Button
          color="custom"
          variant="contained"
          size="small"
          sx={{ ml: 1.6, mt: -18 }}
          onClick={() => fn()}
          disabled={loading11}
        >
          {/* Search */}
          {loading11 ? <CircularProgress size={24} /> : 'Search'}
        </Button>
        {formValues1.commonSearch && (
          <Button
            color="custom"
            variant="contained"
            size="small"
            sx={{ ml: 1.6, mt: -18 }}
            onClick={() => {
              toggleVisibility1();
            }}
          >
            Close
          </Button>
        )}
      </div>
    </>
  );
}
